<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    transition="dialog-top-transition"
    @click:outside="dialog = false"
    @keydown.esc="dialog = false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" color="primary" class=" ma-1"
        >mdi-eye
      </v-icon>
    </template>
    <v-card>
      <v-card-title>
        <span>{{ exersicesItem.name }}</span>
      </v-card-title>
      <v-card-text>
        <v-container class="d-block">
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="12">
              <v-text-field
  outlined
  autofocus
  v-model="decision_grade"
  :rules="rules"
  :label="$t('minimum mark')"
  :error-messages="decisionGradeErrorMessages"
></v-text-field>

            </v-col>

            <v-col cols="12" sm="6" md="4" lg="12">
              <v-autocomplete
                outlined
                :items="itemsBiggestExercise"
                item-text="normaliz"
                item-value="id"
                :label="$t('exercise biggest')"
                v-model="biggestExercise.exercise_id"
                :menu-props="{ closeOnClick: true }"
                @update:search-input="
                  delayedSearchHandler(itemsBiggestExercise)
                "
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="12">
              <v-autocomplete
                outlined
                :eager:="true"
                :items="itemsSmallerExercise"
                item-text="normaliz"
                item-value="id"
                :label="$t('exercise smaller')"
                v-model="SmallerExercise.exercise_id"
                :menu-props="{ closeOnClick: true }"
                search-input.sync="searchHandler"
                @update:search-input="
                  delayedSearchHandler(itemsSmallerExercise)
                "
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="blue darken-1" text>{{
          $t("close")
        }}</v-btn>
        <v-btn
          color="blue darken-1"
          :disabled="validate"
          :loading="loading"
          text
          @click="submit"
          >{{ $t("save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { Exercise } from "@/store/exercise/add";
export default {
  data() {
    return {
      Exercise,
      dialog: false,
      items: Exercise.tableData.lessonData,
      decision_grade: this.exersicesItem.decision_grade,
      biggestExercise: {
        type: ">=",
        exercise_id: this.getWhenId(">="),
      },
      SmallerExercise: {
        type: "<",
        exercise_id: this.getWhenId("<"),
      },
      exercise_id: this.exersicesItem.id,
      lesson_id: this.id,
      searchHandler: "",
      filteredItems: [],
    decisionGradeErrorMessages: [],
    rules: [
      value => {
        const errors = [];

        if (value === "") {
          errors.push("الحقل مطلوب");
        } else if (value > this.exersicesItem.max_grade) {
          errors.push("لايمكن ان تكون العلامة الفارقة اكبر من العلامة العظمى للتمرين");
        }

        this.decisionGradeErrorMessages = errors;
        return errors.length === 0;
      },
    ],
    };
  },
  props: {
    exersicesItem: {
      type: Object,
    },
    id: {
      type: Number,
    },
  },
  computed: {
    loading() {
      return Exercise.exerciseprefState.loading;
    },
    validate() {
      if(this.decisionGradeErrorMessages.length >0)
        return true;
      if (
        this.country_id == "" ||
        this.decision_grade == "" ||
        this.biggestExercise.exercise_id == "" ||
        this.SmallerExercise.exercise_id == ""
      ) {
        return true;
      }
      return false;
    },
    itemsBiggestExercise() {
      const SmallerExerciseId = this.SmallerExercise.exercise_id;
      return Exercise.tableData.lessonData.filter(
        (exercise) =>
          exercise.id !== SmallerExerciseId && exercise.id !== this.exercise_id
      );
    },
    itemsSmallerExercise() {
      const biggestExerciseId = this.biggestExercise.exercise_id;
      return Exercise.tableData.lessonData.filter(
        (exercise) =>
          exercise.id !== biggestExerciseId && exercise.id !== this.exercise_id
      );
    },
  },
  methods: {
    submit() {
      const data = {
        exercises: [
          {
            exercise_id: this.biggestExercise.exercise_id,
            when: this.biggestExercise.type,
          },
          {
            exercise_id: this.SmallerExercise.exercise_id,
            when: this.SmallerExercise.type,
          },
        ],
        decision_grade: this.decision_grade,
        lesson_id: this.lesson_id,
      };
      Exercise.postExercisePreference(data, this.exercise_id);
    },
    removeDiacritics(text) {
      const diacriticsRegex = /[\u0610-\u061A\u064B-\u065F\u0670\u0640]/g;
      return text.replace(diacriticsRegex, "");
    },
    delayedSearchHandler(items) {
      // setTimeout(() => {
        const searchTermWithoutDiacritics = this.removeDiacritics(
          this.searchHandler
        );
        items.filter((item) => {
          const normalizedItemName = this.removeDiacritics(item.name);
          item.normaliz = normalizedItemName;
          const items= normalizedItemName.includes(searchTermWithoutDiacritics);
          return items;
        });
      // }, 1000);
    },
    getWhenId(type) {
      const items = this.exersicesItem.childrens;
      const filteredItems = items.filter((item) => {
        return item.when.includes(type);
      });
      const result = filteredItems.length > 0 ? filteredItems[0].exercise_id : "";
      // console.log(result);
      return result;
    },
  },
};
</script>
